module.exports = __webpack_public_path__ + "img/text.43f049e7.svg";